'use strict';

var cov_2gtfy7y0qh = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\directives\\translations_fr.js',
      hash = 'aea62cbe15e952e4cef73576770947d5893086a0',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\directives\\translations_fr.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 742,
          column: 3
        }
      },
      '1': {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 741,
          column: 7
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 8
          },
          end: {
            line: 3,
            column: 9
          }
        },
        loc: {
          start: {
            line: 3,
            column: 30
          },
          end: {
            line: 742,
            column: 1
          }
        },
        line: 3
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0
    },
    f: {
      '0': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2gtfy7y0qh.s[0]++;
angular.module('app').config(function ($translateProvider) {
  cov_2gtfy7y0qh.f[0]++;
  cov_2gtfy7y0qh.s[1]++;

  $translateProvider.translations('fr', {
    MESSAGE: {
      TITLE: 'Messagerie',
      READ_ALL: 'Lire tous les messages',
      INBOX: 'Boîte de réception',
      SEND_BOX: 'Messages envoyés',
      DRAFT_BOX: 'Brouillons',
      TRASH_BOX: 'Trash',
      REFRESH: 'actualiser',
      REPLY: 'Répondre',
      IMPORTANT: 'Importants',
      VIEW_MSG: 'Afficher le message',
      TO: 'To',
      SUBJECT: 'Sujet',
      FROM: 'De',
      DRAFT: 'Brouillons',
      DISCARD: 'Supprimer',
      CMP_MSG: 'Nouveau Message',
      SEND: 'Envoyer',
      EMAIL_BOX: 'Boîte aux lettres',
      FOLDER: 'Dossier',
      REMOVE: 'Supprimer',
      ERROR: {
        TO: 'Veuillez sélectionner le destinataire!',
        SUBJECT: 'Entrez le sujet'
      }
    },
    LOGIN: {
      TITLE: 'Observatoire du Sahara et du Sahel',
      TITLE1: 'Base de données WEB pour le Suivi-Evaluation',
      TITLE2: 'des Indicateurs de Performance du SAWAP',
      FOOTTITLE: 'Projet de Renforcement de la Résilience par le biais des Services liés à l’Innovation, à la Communication et aux Connaissances (BRICKS)',
      PROFILE: 'Profile',
      LOGOUT: 'Deconnexion',
      ERROR_CHECK: 'Vous avez été déconnecté!',
      ERROR_LOGIN1: 'Erreur dans l\'email ou le mot de passe!',
      ERROR_LOGIN2: 'Le compte est actuellement utilisé!',
      ERROR_LOGIN: ''
    },
    ALERT: {
      NBR_J_L: 'Nombre de jours avant',
      IND_TEXT: 'Alerts d\'indicateurs',
      DOCUMENT: 'nouveaux documents',
      MORE: 'Voir toutes les alertes',
      ALL: 'Toutes les alerts'
    },
    TODO: {
      TITLE: 'Todo List',
      LABEL: 'Libellé'
    },
    HOME: {
      WELCOME: 'Application Web collaborative pour le S&E',
      USER: 'Utilisateur',
      PASS: 'Mot de passe',
      LOGIN: 'Connexion'
    },
    COMMON: {
      SATELLITE: 'Image Satellite',
      CITIES: 'Villes',
      DENIED: 'Access non autorisé',
      RIGHT: {
        VEIWING: 'Consulter',
        UPDATING: 'Editer',
        DELETING: 'Supprimer',
        PAGE: 'Fonction'
      },
      STATUT: {
        NOSTART: 'non démarré',
        PROGRESS: 'En cours',
        DONE: 'Achevé'
      },
      SAVE: 'Valider',
      VIRGULE: ',',
      NEXT: 'Suivant',
      PREV: 'Précedent',
      ADD: 'Nouveau',
      EDIT: 'Modifier',
      DELETE: 'Supprimer',
      SAY: 'Jour',
      PRINT: 'Imprimer',
      SELECT: 'Sélectionner',
      DAY: 'Jour',
      YEAR: 'Année',
      SEM: 'Semestre',
      QUATR: 'Quadrimestre',
      TRIM: 'Trimestre',
      BIM: 'Bimestre',
      MOIS: 'Mois',
      PERIOD: 'Période',
      YEAR_SHORT: 'A',
      SEM_SHORT: 'S',
      QUATR_SHORT: 'Q',
      TRIM_SHORT: 'T',
      BIM_SHORT: 'B',
      MOIS_SHORT: 'M',
      DISPLAY: 'Afficher',
      VALIDATE: 'Valider',
      CANCEL: 'Annuler',
      CONFIRM: 'Etre vous sure?',
      YES: 'Oui',
      NO: 'Non',
      ERROR_DELETE: 'Impossible de supprimer!',
      ERROR_UPDATE: 'Impossible de modifier!',
      ERROR_ADD: 'Impossible d\'ajouter!',
      TITLE_ERROR_ADD: 'Un erreur à été detectée lors de la mise à jour',
      TITLE_ERROR_DELETE: 'La données est utilisée par une autre',
      DATE_FORMAT: 'DD/MM/YYYY',
      DATE_FORMAT_MM_YYYY: 'MMMM YYYY',
      HISTORQ: 'Historique',
      CLOSE: 'Fermer',
      DATE_DP: 'Date Début Prévue',
      ACTUAL: 'Date Réelle',
      DATE_DR: 'Date Début Réelle',
      DATE_FP: 'Date Fin Prévue',
      DATE_FR: 'Date Fin Réelle',
      H_DEB: 'Heure Début',
      H_FIN: 'Heure Fin',
      LIEU: 'Lieu',
      MSG_ADD: 'Ajout effectué !',
      MSG_MODIF: 'Modification effectuée !',
      MSG_DEL: 'Suppression effectuée !',
      TBORD: 'Tableau de bord',
      YEAR_ALL: 'Toutes (*)',
      ALL: 'Tous (*)',
      ALL_E: 'Toutes (*)',
      NONE: 'Aucun',
      NONE_E: 'Aucune',
      SEARCH: 'Rechercher',
      LINECHART: 'Courbe',
      BARCHART: 'Histogramme',
      PIECHART: 'Secteur',
      POLARCHART: 'Radar',
      BEGIN: 'Début',
      END: 'Fin',
      LESS_THAN: 'Plus pétit que',
      GREAT_THAN: 'Plus grand que',
      EGAL_TO: 'Egal à',
      LESS_THAN_E: 'Plus pétite que',
      GREAT_THAN_E: 'Plus grande que',
      EGAL_TO_E: 'Egale à',
      OPEN: 'Ouvrir',
      DOWNLOAD: 'Télecharger',
      QUIT: 'Quitter'
    },
    MENU: {
      ALERT: 'Alertes',
      D_B: 'Données de base',
      DO: 'Projets',
      D_T: 'Découpage Temporel',
      D_P: 'Découpage Périodique',
      D_PL: 'Découpage Plan',
      UN: 'Unités',
      AC: 'Acteurs',
      S_F: 'Sources de Financement',
      P_G: 'Plan Géographique',
      S_G: 'Structure Géographique',
      T_I: 'Types Indicateurs',
      IN: 'Indicateurs',
      IN_T: 'Indicateurs ',

      R_F: 'Cadre des resultats',
      P_L: 'Personnaliser libellé',
      P_LO: 'Plan logique',
      ST: 'Structure',
      P_B: 'Plan Budgétaire',
      P_M: 'Plan Marchés',
      FL: 'Flag',
      PL: 'Planification',
      P_A: 'Planification Activités',
      P_AN_PTBA: 'Plan Annuel (PTBA)',
      IMP_BUDG: 'Importation Budgets',
      G_F_PF: 'Générer le fichier pré formaté',
      I_B: 'Importer les budgets',
      P_I: 'Planification Indicateurs',
      S_E: 'Suivi d\'execution',
      S_A: 'Suivi Activités',
      I_C: 'Importation Coûts',
      I_COUT: 'Importer les coûts',
      S_PTBA: 'Suivi PTBA',
      S_PTBP: 'Suivi PTB pluriannuel',
      T_B_A: 'Tableau de bord Activités',
      C_GANTT: 'Chronogramme (Gantt)',
      P_AC: 'Plan d\'action',
      R_P: 'Requêtes Perso.',
      MA: 'Marché',
      S_M: 'Suivi Marché',
      S_PPM: 'Suivi PPM',
      S_I: 'Suivi Indicateur',
      S_I_IOV: 'Suivi Indicateur(IOV)',
      S_I_G: 'Suivi Géographique Indicateurs',
      T_B_I: 'Tableau de bord Indicateur',
      SY: 'Synthèse',
      C_L: 'Cadre Logique',
      S_C_L: 'Suivi du cadre logique',
      S_C: 'Suivi Contexte',
      G_R: 'Gestion des risques',
      P_M_R: 'Plan de mitigation des risques',
      F_P: 'Facteurs Positifs',
      E_T: 'Enseignements Tirés',
      M_R: 'Missions / Réunions',
      T_M: 'Types de missions',
      MIS: 'Missions',
      C_M: 'Chronogramme Missions',
      CA_MIS: 'Calendrier Missions',
      T_R: 'Types Réunions',
      RES: 'Réunions',
      CA_RE: 'Calendrier Réunions',
      B_D: 'Base Documentaire',
      T_RA: 'Types Rapports',
      CA_R: 'Calendrier Rapports',
      C_D: 'Classeur Documents',
      PH: 'Photothèque',
      AD: 'Administration',
      G_U: 'Gestion des utilisateurs',
      GR_U: 'Groupes Utilisateurs',
      U_C: 'Utilisateurs Connectés',
      J_C: 'Journal des Connexions',
      R_I: 'Profils'
    },
    PROJECT: {
      TITLE: 'Projets',
      NEWP: 'Ajouter',
      FROM: 'de',
      TO: 'à',
      PROCESS: 'En cours...',
      COMPLETE: 'Achèvement à',
      PROJECT: 'Projet',
      INFO: 'Informations',
      CODE: 'Code',
      LABEL: 'Libellé',
      CURRENCY: 'Monnaie',
      D_DEB: 'Date Début',
      D_FIN: 'Date Fin',
      COOR: 'Coordonnées',
      ADR: 'Adresse',
      PAYS: 'Pays',
      TEL: 'Telephone',
      FAX: 'Fax',
      MAIL: 'E-mail',
      OTHER: 'Autres',
      AGENC: 'Agence',
      DESCR: 'Description',
      CODE_ERR: 'Le code est atrribué',
      CONFIRM_DELETE: 'Voulez vous suprimer ce projet?',
      SELECT: 'Selectionner',
      CHANGE_PIC: 'Changer l\'image',

      GOAL: 'Objectif',
      TARGET: 'Cible',
      AREA: 'Zone',
      DATE_MID: 'Date revue mi-parcours',
      STATUS: 'Statut',
      COST: 'Coût',
      FINAN: 'Financement'
    },
    BTN: {
      ADD: 'Ajouter',
      MOD: 'Modifier',
      DEL: 'Supprimer',
      CAN: 'Annuler',
      PRI: 'Imprimer',
      VAL: 'Valider',
      NEX: 'Page Suivante',
      PRE: 'Page Précedente'
    },
    FN_UNIT: {
      LST_TI: 'Liste des unités',
      Ed_TI: 'Détails unité',
      COD: 'Code',
      LAB: 'Libellé',
      TYP: 'Type',
      FOR: 'Format',
      CB_N: 'Numérique',
      CB_P: '%',
      CB_B: 'Booléen',
      CB_T: 'Texte',
      CB_D: 'Date',
      NEWU: 'Nouvelle unité',
      COLU: 'Unité',
      CONFIRM_DELETE: 'Voulez vous supprimer cette unité?'

    },
    FN_ACTORS: {
      LST_AC: 'Liste Acteurs',
      ED_AC: 'Fiche Acteur',
      COD: 'Code',
      NOM: 'Nom',
      PRE: 'Prénom(s)',
      FON: 'Fonction',
      IMG: 'Image',
      GRO: 'Groupe',
      NEWA: 'Nouvelle Acteur',
      LAB_AC: 'Activités',
      LAB_LSTAC: 'Liste Activités',
      LAB_MI: 'Missions',
      LAB_LSTMI: 'Liste Missions',
      LAB_RE: 'Réunions',
      LAB_LSTRE: 'Liste Réunions',
      LAB_RA: 'Rapports',
      LAB_LSTRA: 'Liste Rapports',
      LAB_TYPRA: 'Type Rapport',
      FILT: 'Filtre',
      ETAV: 'État d\'avancement',
      RESNIVO: 'Niveau de responsabilité',
      CHECK_A1: 'En cours',
      CHECK_A2: 'Achevé',
      CHECK_A3: 'En rétard',
      CHECK_A4: 'En avance',
      CHECK_A5: 'Global',
      CHECK_A6: 'Local',
      CONFIRM_DELETE: 'Voulez vous supprimer ce acteur?'

    },
    FN_SFIN: {
      LST_FIN: 'Sources de financement',
      ED_FIN: 'Détails source',
      CONFIRM_DELETE: 'Voulez vous supprimer cette Source?'
    },
    FN_TYPINDIC: {
      LST_TYP: 'Liste des Types d\'indicateurs',
      ED_TYP: 'Détails Type d\'indicateur',
      COL_COLOR: 'Couleur',
      COLOR_BLUE: 'Bleu',
      COLOR_CRYAN: 'Cyan',
      COLOR_GREEN: 'Vert',
      COLOR_YELOW: 'Jaune',
      COLOR_ORANGE: 'Orange',
      COLOR_RED: 'Rouge',
      COLOR_PINK: 'Rose',
      COLOR_PURPLE: 'Violet',
      COLOR_GREY: 'Gris',
      COLOR_BLACK: 'Noir',
      CONFIRM_DELETE: 'Voulez vous supprimer ce Type d\'indicateur?'
    },
    DASHBOARD: {
      TITLE: 'Tableau de bord',
      V_R: 'Valeur Réference',
      V_C: 'Valeur Cible',
      FROM: 'de',
      TO: 'à',
      PROCESS: 'En cours...',
      COMPLETE: 'Achèvement à',
      SIT_INDIC: 'Situation des indicateurs',
      REP_ACTIVITE: 'Répartition des activités',
      PHY: 'Taux Physique',
      FIN: 'Taux Financier',
      GRAPHE_PERF: 'Graphe de Performance',
      SUIV_PTBA: 'Suivi PTBA (Evolution des taux d\'execution)',
      DASHBOARD: 'Tableau de bord',
      RESUME_PROJECT: 'Résumé du Projet ',
      EVOLUTION_TABLE: 'Évolution de l’Indicateur ',
      REALIZE: '% réalisé Fin Projet',
      YEAR: 'Année',
      PERIOD: 'Période'
    },
    TIME_DIVISION: {
      PERIOD: 'Pérode',
      PTBA: 'PTBA en cours',
      PLAN_AN: 'Plan Annuel',
      LEVEL: 'Niveau',
      BEGIN: 'Début',
      END: 'Fin',
      LABEL: 'Libellé'
    },
    GEOGRAPHIC_PLAN: {
      ADD__: 'Ajouter une localité',
      ADD: 'Ajouter sous-localité',
      SUM: 'Somme',
      MOY: 'Moyenne',
      MAXI: 'Maximum',
      MINI: 'Minimum',
      AGGREGA: 'Aggrégation',
      CHAMPPERSO: 'Champs Personnalisés',
      LABEL: 'Libellé',
      CONFIRM_DELETE: 'Voulez vous supprimer le champ?',
      LONG: 'Longueur',
      ERROR_UPDATE_LONG: 'Impossible de modifier la longueur.',
      CONFIRM_DELETE_LEVEL: 'Voulez vous supprimer ce niveau?',
      CONFIRM_DELETE_LOCALTION: 'Voulez vous supprimer cette localité?',
      CODE: 'Code',
      DESCRP: 'Description',
      IMPORT: 'Importer le plan géographique'
    },
    INDICATOR: {

      LESS_THAN: 'La valeur doit être inférieure ou ègale à {{valeur}}',
      GREAT_THAN: 'La valeur doit être supérieure ou ègale à {{valeur}}',
      EGAL_TO: 'La valeur doit être ègale à {{valeur}}',
      BEETWEEB: 'La valeur doit être comprise entre {{valeur_min}} et {{valeur_max}}',
      ERROR_UPDATE: 'Une erreur s\'est produite lors de la mise à jour!',

      ERROR_DECOUP_PLAN: {
        TITLE: 'Erreur',
        VALUE: 'Veuillez entrer une valeur',
        DATE_RELEVE: 'Veuillez entrer la date prévue',
        DATE_ALERT: 'Veuillez entrer la date d\'alerte',
        DATE_RELEVE_T: 'La date prévue doit être supérieure au début de la période et à la date début de l\'indicateur'
      },

      SELECT: 'Liste',
      LOCATION: 'Localité',
      CALMETHOD: 'Methode de calcul',
      CRITERIA: 'Citères ',
      CODE: 'Code',
      KEY_KPI: 'Indicateur clé',
      NAME: 'Nom',
      NAME_FRENCH: 'Nom (Français)',
      NAME_ENG: 'Nom (Anglais)',
      DEF: 'Définition /  Description',
      UNIT: 'Unité',
      TYPE: 'Type',
      CLASS: 'Classe',
      KEY: 'Indicateurs clés',
      VAL_POSS: 'Valeurs Possibles',
      FORMULA: {
        INVALID: 'Formule Incorrecte',
        NONEINDIC: 'Aucun indicateur dans la formule'
      },
      BEGIN: 'Date Début',
      END: 'Date Fin',
      FREQUENCE: 'Fréquence',
      NIV_GEO: 'Niveau Géographique',
      AGGREGA: 'Aggrégation',
      GROUP_CIBLE: 'Groupe Cible',
      HYPOTHESE: 'Hypothèse',
      MOY_VERIF: 'Moyen de vérification',
      TECH_COLL: 'Technique de collecte',
      TARGET: 'Valeur Cible (Finale)',
      REF: 'Valeur réference (Initiale)',
      TARGET_VAL: 'Valeur Cible',
      REAL_VAL: 'Valeur Réalisée',
      VARIANCE: 'Ecart',
      TRANS: 'Transversal',
      SIMPL: 'Simple',
      COMPO: 'Composite',
      CUMUL: 'Cumulatif',
      COMPL: 'Complèxe',
      SUM: 'Somme',
      MOY: 'Moyenne',
      MAXI: 'Maximum',
      MINI: 'Minimum',
      NONE: 'Aucun',
      MOD_UN: 'La modification de l\'unité entraînera la perte de tous les relevés.\nVoulez-vous continuer?',
      MOD_NG: 'La modification du niveau géographique entraînera la perte de tous les relevés.\nVoulez-vous continuer?',
      MOD_DATE: 'La modification des dates pourrait entraîner la perte de plusieurs relevés.\nVoulez-vous continuer?',
      MOD_PER: 'La modification de la périodicité pourrait entraîner la perte de plusieurs relevés.\nVoulez-vous continuer?',
      MOD_CLS: 'La modification de la classe entraînera la perte de tous les relevés.\nVoulez-vous continuer?',
      LABEL_VP: 'Libellé',
      POUND: 'Pondération',
      PLAN: 'Planification',
      DATE_R: 'Date prévue',
      VALUE: 'Valeur',
      BUDGET: 'Budget',
      COST: 'Coût',
      REL: 'Relevé Indicateur',
      RAPP: 'Rapport Indicateur',
      PIC: 'Image',
      IN_MON: 'Suivi Indicateur',
      MON: 'Suivi',
      DATA_FIN: 'Données Financières',
      FOLLOW_FIN: 'Suivi financier',
      DISPLAY_CODE_LOC: 'Afficher le code des localités',
      COMMENTS: 'Commentaires',
      RESPO: 'Responsable',
      DISPLAY_PL: 'Afficher ',
      ACHEVE: '% Réalisé',
      SOCIO_ECO: 'Socio-économique',
      SPATIAL: 'Spatial',
      GRAPHE_COMBINE: 'Graphe combiné',
      CONFIRM_DELETE: 'Voulez vous supprimer ce indicateur?',
      CONFIRM_DELETE_RELEVE: 'Voulez vous supprimer ce relevé?',
      CONFIRM_DELETE_PLAN: 'Voulez vous supprimer cette planification?',
      DATE_ALERT: 'Date Alerte',
      GLOBAL: {
        TITLE: 'Valeurs Référence & Cible finale',
        LOCATION: 'localité',
        BEGIN: 'Date Début',
        END: 'Date Fin',
        TARGET: 'Valeur cible finale',
        REF: 'Valeur de référence',
        COMMENTS: 'Commentaires',
        ERROR: {
          DATE: 'La date fin doit être supérieure à la date début',
          TARGET_VALUE: 'Veuillez renseigner la valeur cible!',
          REF_VALUE: 'Veuillez renseigner la valeur de référence!',
          DATE_D: 'Veuillez renseigner la Date Début!',
          DATE_F: 'Veuillez renseigner la Date Fin!'
        }

      },
      DASHBOARD: {
        TITLE2: 'Taux de réalisation par localité',
        TITLE1_1: 'Tableau de Suivi de l’indicateur',
        TITLE1_2: 'Graphe d’évolution de l’indicateur par année',
        LEGEND: 'Taux de réalisation',
        TITLE: 'TABLEAU DE BORD INDICATEUR',
        PAGE1TITLE: 'TABLEAU DE BORD 1',
        PAGE2TITLE: 'TABLEAU DE BORD 2',
        PAGE2SUBTITLE1: 'Évolution de l’Indicateur par localité',
        PAGE2SUBTITLE2: 'Graphe d’Évolution de l’Indicateur par localité '
      },
      MENU: {
        EDIT: 'Éditer  l’Indicateur',
        PLAN: 'Planifier l’Indicateur',
        RELE: 'Relevé  de l’Indicateur',
        FICHE: 'Fiche de l’Indicateur',
        IMAGE: 'Changer l’image',
        RIGHT: 'Droits Indicateur',
        RAPPORT: 'Rapport',
        SPATIAL: 'Carte',
        LEGEND: 'Legende'
      },
      RIGHT: {
        TITLE: 'Droits Indicateur'
      },
      SHEET: {
        SHEET: 'Fiche',
        TITLE: 'Fiche indicateur',
        NAME: 'Nom de l’Indicateur',
        DESCRP: 'Description',
        TYPE: 'Type',
        RAT_CL: 'Rattachement Cadre logique',
        U_MES: 'Unité de mesure',
        PER_COL_SUI: 'Périodicité de collecte et de suivi',
        NG: 'Niveau Géographique',
        RESPO: 'Responsable de Collecte',
        TECH: 'Technique de collecte',
        SRC: 'Source de vérification',
        FORMULA: 'Formule de calcul',
        VAL_REF: 'Valeur de réference',
        VAL: 'Valeur',
        EVO: 'Évolution de l’Indicateur'
      },
      SPATIALS: {
        DATA: 'couches de données',
        LAYERS: 'Couches',
        LABEL: 'Libellé',
        PERIODIC: 'Périodique',
        URL: 'URL',
        PROPERTY: 'Format',
        DATA_LAYER: 'Couche de données'
      }
    },
    LOGICAL_PLAN: {
      ADD: 'Ajouter',
      HAS_INDIC: 'Associer un indicateur',
      LABEL: 'Libellé',
      LONG: 'Longueur',
      ERROR_UPDATE_LONG: 'Impossible de modifier la longueur.',
      CONFIRM_DELETE_LEVEL: 'Voulez vous supprimer ce niveau?',
      CONFIRM_DELETE: 'Voulez vous supprimer cette donnée?',
      CODE: 'Code',
      DESCRP: 'Description',
      LABEL_C: 'Libellé court',
      LABEL_L: 'Libellé long',
      IMPORT: 'Import...'
    },
    FLAG: {
      LABEL: 'Libellé',
      MIN: 'Min',
      MAX: 'Max',
      COLOR: 'Color',
      ERROR: {
        LABEL: 'Le libellé existe déjà.',
        CHEVAL: 'La période est à chevale sur une autre',
        IN: 'La période est incluse dans une autre',
        OUT: 'La période inclus une autre'
      }
    },
    FRAME_RESULT: {
      INDIC: 'Indicateur',
      T_I: 'Filtre'
    },
    ACTIVITY: {
      START: 'Date Début',
      END: 'Date Fin',
      UNIT: 'Unité',
      UNIT_COST: 'Coût Unitaire',
      CAL_AUTO: 'Calcul Automatique',
      BUDGET: 'Budget',
      COST_A: 'Coût Réel',
      RESPO: 'Responsable',
      COMMENT: 'Commentaires',
      IMPUT: 'Intrants',
      TOTAL: 'Total',
      CONT_LOC: 'Suivre les marchés par localités',
      CONT_UNK: 'Marché Unique',
      NUM: 'Numéro',
      OWN: 'Titulaire',
      OBJECT: 'Objet',
      COST: 'Montant',
      SIGN: 'Signature',
      BEGIN_CONTRACT: 'Date Début',
      END_CONTRACT: 'Date Fin',
      BEGIN_D: 'Date Début',
      END_D: 'Date Fin',
      PLAN: {
        TITLE: 'Planification',
        REVIEW: 'Révisée',
        INIT: 'Initiale',
        GLOBAL: 'Globale',
        DURATION: 'Durée',
        TYPE: 'Type',
        AMOUNT: 'Quantité',
        COST: 'Coût',
        LOCATION: 'Localité',
        YEAR: 'Année',
        PERIOD: 'Période'
      },
      REAL: {
        TITLE: 'Réalisation'
      },
      DASHBOARD: {
        ALL_LOC: 'Toutes les localités',
        ANY_LOC: 'Une localité',
        BY_LOC: 'Par Localité',
        TITLE: 'Tableau de bord',
        RATE_PHY: 'Taux Physique',
        RATE_FINANC: 'Taux Financiere',
        TITLE2: 'Taux de réalisation par localité',
        TITLE1_1: 'Tableau de Suivi de l’indicateur',
        TITLE1_2: 'Graphe d’évolution de l’indicateur par année'
      },
      AWPB: {
        TITLE: 'Programme de travail et budget Annuel (PTBA)',
        TITLE_YEAR: 'Programme de travail et budget Multi-annuel'
      }
    },
    GANTT: {
      TITLE: 'Diagramme de gantt',
      LIMIT: 'Limite Période',
      TYPE: 'Type Planning',
      START: 'Date début',
      END: 'Date fin',
      DISPLAY: 'Afficher les barres des niveaux supérieurs',
      LEGEND: 'Legende',
      PLAN: 'Planning',
      ACTUAL: 'Réel',
      ACTOR: 'Acteurs',
      GEO: 'Plan Géographique',
      ZOOM: 'Zooming'
    },
    CONTRACT: {
      LOC: 'Localité',
      N_MAR: 'N° Contrat',
      PROGRESS: 'En cours',
      STEP: 'Etape'
    },
    PROCUREMENT: {
      CONFIRM_DELETE: 'Voulez vous supprimer le marché??',
      CODE: 'Code',
      LABEL: 'Libellé'
    },
    REPORT_CAT: {
      LABEL: 'Libellé',
      PERIOD: 'Périodicité',
      DELAI: 'Delai de production',
      RECIPIENT: 'Destinataire',
      FORMAT: 'Format du rapport',
      RESPO: 'Responsable',
      SELECT: 'Selectionner le fichier',
      CHANGE: 'Modifier',
      REMOVE: 'Supprimer',
      CONFIRM_DELETE: 'Voulez vous supprimer ce type de rapport?',
      PERSON_ALERT: 'Acteurs à informer'
    },

    DOCUMENT: {
      CLS: 'Classeur',
      ADD_FILE: 'Ajouter un Classeur',
      ADD_DOC: 'Ajouter un Document',
      CODE: 'Code',
      DESCRIP: 'Description',
      CONFIRM_DELETE_FOLDER: 'Voulez vous supprimer le classeur?',
      CONFIRM_DELETE_THEME: 'Voulez vous supprimer le theme?',
      CONFIRM_DELETE_TYPE: 'Voulez vous supprimer le type?',
      CONFIRM_DELETE_PHYS: 'Voulez vous supprimer l\'emplacement physique?',
      CONFIRM_DELETE_FILE: 'Voulez vous supprimer ce document?',
      RECIPIENT: 'Destinataires',
      REFERENCE: 'Réference',
      PUBLICATION: 'Publication',
      PUBLIC: 'Publique',
      TITLE: 'Titre',
      AUTHOR: 'Auteur',
      DOC_TYPE: 'Type document',
      THEME: 'Theme',
      PHYS_LOC: 'Emplacement physique',
      SUMMARY: 'Resumé',
      LABEL: 'Libellé',
      MAIN: 'Principal',
      UPLOAD: 'Charger un fichier'
    },
    PHOTOLIBRARY: {
      REF: 'Réference',
      TITLE: 'Titre',
      DATE: 'Date',
      PUBLIC: 'Publique',
      LOCATION: 'Localité',
      LAT: 'Latitude (GPS)',
      LONG: 'Longitude (GPS)',
      AUTHOR: 'Auteur',
      SUMMARY: 'Resumé',
      ADD_DOC: 'Ajouter une Photo',
      ADD_FILE: 'Ajouter un projet',
      CONFIRM_DELETE_PHOTO: 'voulez vous supprimer cette photo'
    },
    G_U: {
      EMAIL: 'Email',
      NAME: 'Nom',
      SUP: 'Superviseur',
      PRENOM: 'Prénom(s)',
      MDP: 'Mot de passe',
      CONF: 'Confirmation',
      ACTOR: 'Acteurs',
      ACTORLIST: 'Assign des acteurs',
      CONFIRM_DELETE: 'DVoulez vous supprimer cet utilisateur',
      ERRORCONFPSW: 'Mots de passe non identiques',
      ERRORPSW: 'Le mot de passe doit contenir au moins 8 caractères'
    },

    GR_U: {
      CODE: 'Code',
      LABEL: 'Libellé',
      CONFIRM_DELETE: 'Voulez vous supprimer ce groupe?',
      USER: 'Assigner des utilisateurs',
      LOCATION: 'localités',
      LOCATION_ONLY: 'Localité seule',
      LOCATION_ALL: 'Sous-localités'
    },
    RIGHT: {
      USER: 'Utilisateurs',
      ADMIN: 'Administrateur',
      PRIVIL: 'Droits',
      LABEL: 'Libellé',
      CONFIRM_DELETE: 'Voulez vous supprimer ce profil?'
    }
  });
});